import { css } from '@emotion/react';

const makeCountdownTimerStyling = ({ theme }) => {
  return {
    text: css({
      fontSize: theme.mvf.fontSize.little,
      [theme.breakpoints.up('tabletSmall')]: {
        fontSize: theme.mvf.fontSize.mini,
      },
      color: theme.mvf.palette.text.secondaryTextColor,
    }),
    timer: css({
      fontSize: theme.mvf.fontSize.little,
      [theme.breakpoints.up('tabletSmall')]: {
        fontSize: theme.mvf.fontSize.mini,
      },
      color: theme.mvf.palette.text.secondaryTextColor,
      marginRight: theme.mvf.spacing.tiny,
      position: 'relative',
      top: '2px',
    }),
  };
};

export default makeCountdownTimerStyling;
